"use client";

import { sameScriptText, scriptTextVersion } from './script-text-version';

export interface ScriptConflict<T = unknown> { current: T | null }
const conflicts = new Map<string, ScriptConflict>();
const listeners = new Set<() => void>();

export const getScriptConflict = <T = unknown>(id: string): ScriptConflict<T> | undefined => conflicts.get(id) as ScriptConflict<T> | undefined;
export function subscribeScriptConflicts(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
export function pauseScriptSaves(id: string, current: unknown): void {
  const previous = conflicts.get(id);
  if (previous && current && previous.current && (scriptTextVersion(current) < scriptTextVersion(previous.current)
    || (scriptTextVersion(current) === scriptTextVersion(previous.current) && sameScriptText(current, previous.current)))) return;
  conflicts.set(id, { current });
  listeners.forEach((listener) => listener());
}
export function resumeScriptSaves(id: string): void {
  if (conflicts.delete(id)) listeners.forEach((listener) => listener());
}
